import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCity, faPhone, faEnvelope, faLink, faR, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faVk, faTelegram, faYoutube, faYandex } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ExhibitorCategories from './ExhibitorCategories';
import getLogo from '../../utils/getLogo';
import FavoritesIndicator from '../favorites/FavoritesIndicator';
import { getCountryName } from '../../utils/countries';
import { useNavigate } from 'react-router-dom';

const ExhibitorLeft = ({ exhibitor }) => {
	const { t, i18n } = useTranslation();
    const navigate = useNavigate();
	const lang = i18n.language;
    const img = getLogo(exhibitor);

	return (
        <React.Fragment>
		<div className='Exhibitor-left'>
            <div className='mobile'>
				<h1>{exhibitor.name[lang]}</h1>

				{exhibitor.brief[lang] &&
				<p>{exhibitor.brief[lang]}</p>}
			</div>

            <div className='contacts'>
            <div className='logo'>
	    	    <img src={img} alt='logo' onClick={() => navigate(`../exhibitor/${exhibitor._id}`)}/>
                {exhibitor.stickers?.length > 0 &&
                <ul>
                    {exhibitor.stickers.map((sticker, index) => (
                        <li
                            key={index}
                            style={{
                                color: sticker.color,
                                backgroundColor: sticker.background,
                            }}
                        >
                            {sticker.text[lang]}
                        </li>
                    ))}
                </ul>}
            </div>

            <div className='text'>
            {exhibitor.contacts && <h2>{t('exhibitor.contacts')}</h2>}
            <div className='list'>
                {exhibitor.contacts?.country &&
                <div className='item check'>
                    <span className='icon'><FontAwesomeIcon icon={faGlobe} fixedWidth/></span>
                    <div className='text'>{getCountryName(exhibitor.contacts.country, lang)}</div>
                </div>}
                {exhibitor.contacts?.city &&
                <div className='item check'>
                    <span className='icon'><FontAwesomeIcon icon={faCity} fixedWidth/></span>
                    <div className='text'>{exhibitor.contacts.city[lang]}</div>
                </div>}
                {exhibitor.contacts?.phone &&
                <div className='item check'>
                    <span className='icon'><FontAwesomeIcon icon={faPhone} fixedWidth/></span>
                    <div className='text'>
                        <a href={'tel:' + exhibitor.contacts.phone}>
                            {exhibitor.contacts.phone}
                        </a>
                    </div>
                </div>}
                {exhibitor.contacts?.email &&
                <div className='item check'>
                    <span className='icon'><FontAwesomeIcon icon={faEnvelope} fixedWidth/></span>
                    <div className='text'>
                        <a href={'mailto:' + exhibitor.contacts.email}>
                            {exhibitor.contacts.email}
                        </a>
                    </div>
                </div>}
                {exhibitor.contacts?.www &&
                <div className='item check'>
                    <span className='icon'><FontAwesomeIcon icon={faLink} fixedWidth/></span>
                    <div className='text'>
                        <a href={exhibitor.contacts.www} target='_blank' rel='noreferrer'>
                            {exhibitor.contacts.www.replace(/^https?:\/\//i, '')}
                        </a>
                    </div>
                </div>}
                <FavoritesIndicator type='exhibitor' object={exhibitor}/>
            </div>{/* .list */}
            </div>{/* .text */}
            </div>{/* .contacts */}
        </div>
        
        {/* Стенд */}
        {exhibitor.stand &&
        <div className='Exhibitor-left'>
            <h2>{t('exhibitor.stand')}</h2>
            <div className='list'>
            <div className='item check'>
                <span className='icon'><FontAwesomeIcon icon={faLocationDot} fixedWidth/></span>
                <div className='text'>{exhibitor.stand}</div>
            </div>
            </div>
        </div>}

        {/* Ссылки на соцсети */}
        {(exhibitor.links && (exhibitor.links.youtube || exhibitor.links.rutube ||
          exhibitor.links.vk || exhibitor.links.telegram || exhibitor.links.yazen)) &&
        <div className='Exhibitor-left'>
            <h2>{t('exhibitor.links')}</h2>
            {exhibitor.links.youtube &&
            <a href={exhibitor.links.youtube} target='_blank' rel='noreferrer'>
                <FontAwesomeIcon icon={faYoutube} className='icon' size='2x'/>
            </a>}
            {exhibitor.links.rutube &&
            <a href={exhibitor.links.rutube} target='_blank' rel='noreferrer'>
                <FontAwesomeIcon icon={faR} className='icon' size='2x'/>
            </a>}
            {exhibitor.links.vk &&
            <a href={exhibitor.links.vk} target='_blank' rel='noreferrer'>
                <FontAwesomeIcon icon={faVk} className='icon' size='2x'/>
            </a>}
            {exhibitor.links.telegram &&
            <a href={exhibitor.links.telegram} target='_blank' rel='noreferrer'>
                <FontAwesomeIcon icon={faTelegram} className='icon' size='2x'/>
            </a>}
            {exhibitor.links.yazen &&
            <a href={exhibitor.links.yazen} target='_blank' rel='noreferrer'>
                <FontAwesomeIcon icon={faYandex} className='icon' size='2x'/>
            </a>}
        </div>}
        
        {exhibitor.categories.length > 0 && <ExhibitorCategories categories={exhibitor.categories}/>}
        </React.Fragment>
	);
};

ExhibitorLeft.propTypes = {
    exhibitor: PropTypes.object.isRequired,
};

export default ExhibitorLeft;
